import PropTypes from 'prop-types';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import LinkTextField from 'src/components/widgets/link-textfield'

export const DetailView = (({ item, subjectClicked }) => {

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>

          <Grid xs={12} md={4} display="flex" alignItems="center">
            <Stack alignItems="center" direction="row" spacing={1}>
              <Typography sx={{ 
                  fontWeight: 'bold', 
                  textTransform: 'uppercase', 
                  mr: 15, 
                  color: 'primary.main'
                }}>{item.subject?.title}
              </Typography>
              <LinkTextField value={item.subject?.name}
                onClick={() => subjectClicked(item.subject)} />
            </Stack>
          </Grid>
          
          <Grid xs={12} md={4}>
            <ReadOnlyTextField label="Ngày tạo" value={item.createdAt} />
          </Grid>

          <Grid xs={12} md={4}>
            <ReadOnlyTextField label="Trạng thái" value={item.ticketInfo?.text} color={{label: item.ticketInfo?.color}} />
          </Grid>

          <Grid xs={12} md={12}>
            <ReadOnlyTextField label="Nội dung" value={item.reason} />
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
});

DetailView.propTypes = {
  item: PropTypes.object.isRequired
};